import { switchMap, of, catchError } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { getTypeaheadOptions } from 'constants/routes'

function getTypeaheadSuggestions(searchTerm) {
  const url = `${getTypeaheadOptions}?searchTerm=${encodeURIComponent(searchTerm)}`;

  return fromFetch(url, {
    headers: {
      'Accept': 'application/json',
    }
  }).pipe(
    switchMap((response) => response.json()),
    catchError(() => of([]))
  );
}

export default getTypeaheadSuggestions;
